import { Helmet } from 'react-helmet-async';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'ClearSlot',
  url: 'https://clearslot.io',
  description: 'Neutral booking coordination infrastructure for restaurant booking platforms.',
  sameAs: [],
};

const softwareApplicationSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'ClearSlot',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  offers: { '@type': 'Offer', price: '0' },
};

export const OrganizationJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
  </Helmet>
);

export const SoftwareApplicationJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(softwareApplicationSchema)}</script>
  </Helmet>
);

const techArticleSchema = {
  '@context': 'https://schema.org',
  '@type': 'TechArticle',
  headline: 'ClearSlot Technical Brief',
  description:
    'Architecture, signal model, and integration reference for ClearSlot booking coordination infrastructure.',
  url: 'https://clearslot.io/technical-brief',
  author: { '@type': 'Organization', name: 'ClearSlot' },
  publisher: { '@type': 'Organization', name: 'ClearSlot', url: 'https://clearslot.io' },
};

const executiveArticleSchema = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'ClearSlot Executive Summary',
  description: 'Business case and ROI model for integrating ClearSlot booking coordination.',
  url: 'https://clearslot.io/executive-summary',
  author: { '@type': 'Organization', name: 'ClearSlot' },
  publisher: { '@type': 'Organization', name: 'ClearSlot', url: 'https://clearslot.io' },
};

export const TechArticleJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(techArticleSchema)}</script>
  </Helmet>
);

export const ArticleJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(executiveArticleSchema)}</script>
  </Helmet>
);

